@if (order$ | async; as order) {
  @if (!isEditable) {
    @if (orderActions$ | async; as orderActions) {
      @for (action of orderActions; track action) {
        @if (action === 'REORDER') {
          <a class="btn btn-block btn-action" (click)="reOrder(order)">
            {{ 'knbrOrderDetails.actions.reorderAction' | cxTranslate }}
          </a>
        }
        @if (action === 'CANCEL_ORDER') {
          <a class="btn btn-block btn-action" (click)="openCancelOrderModal()">
            {{ 'knbrOrderDetails.actions.cancelAction' | cxTranslate }}
          </a>
        }
        <!--  <ng-container *ngIf="action === 'RETURN_ORDER'">
        <a (click)="returnOrder('RMA')" class="btn btn-block btn-action">
          {{ 'knbrOrderDetails.actions.returnRMAAction' | cxTranslate }}
        </a>
      </ng-container>
      <ng-container *ngIf="action === 'REP_RETURN_ORDER'">
        <a (click)="returnOrder('ZRRE')" class="btn btn-block btn-action">
          {{ 'knbrOrderDetails.actions.returnZRREAction' | cxTranslate }}
        </a>
      </ng-container>-->
      @if (action === 'EDIT_ORDER') {
        <a class="btn btn-block btn-primary" (click)="editOrder()">
          {{ 'knbrOrderDetails.actions.editAction' | cxTranslate }}
        </a>
      }
    }
  }
}
@if (isEditable) {
  <ng-container>
    <a class="btn color-knbr-primary btn-block text-white" (click)="saveEditOrder()">
      {{ 'knbrOrderDetails.actions.saveEditOrder' | cxTranslate }}
    </a>
  </ng-container>
  <ng-container>
    <button
      type="button"
      [disabled]="editDisable$ | async"
      class="btn btn-block btn-action"
      (click)="cancelEditOrder()"
      >
      {{ 'knbrOrderDetails.actions.cancel' | cxTranslate }}
    </button>
  </ng-container>
}
}
